<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title">CONTENTS<span epub:type="pagebreak" id="page5"></span></p>
<p class="toc1"><a href="#/xhtml/08_Dramatis_Personae">Dramatis Personae</a></p>
<p class="toc1"><a href="#/xhtml/09_Prologue">Prologue: 16 March 1917</a></p>
<p class="toc1"><a href="#/xhtml/10_Introduction">Introduction: The Navy at War</a></p>
<p class="toc1a"><a href="#/xhtml/11_Part01"><b>Part One: The German auxiliary Cruiser <i>Guerre de Course</i></b></a></p>
<p class="toc1"><a href="#/xhtml/12_Chapter01">1   A Change of Strategy, 1914</a></p>
<p class="toc1"><span href="#/xhtml/13_Chapter02" title="Link target outside of Sample">2   Cruiser Warfare</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample">3   The Escapee, 1914</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter04" title="Link target outside of Sample">4   Dancing Elephants, 1914</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter05" title="Link target outside of Sample">5   The Weary Traveller, 1914–1915</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter06" title="Link target outside of Sample">6   Enter the U-boat, 1914–1916</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter07" title="Link target outside of Sample">7   The Seagull, 1915–1917</span></p>
<p class="toc1a"><span href="#/xhtml/19_Part02" title="Link target outside of Sample"><b>Part Two: Blockade</b></span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter08" title="Link target outside of Sample">8   The Northern Patrol, 1914</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter09" title="Link target outside of Sample">9   Enter the Merchantmen, 1914–1915</span></p>
<p class="toc1"><span href="#/xhtml/22_Chapter10" title="Link target outside of Sample">10 The Volunteers</span></p>
<p class="toc1"><span href="#/xhtml/23_Chapter11" title="Link target outside of Sample">11 Captains Courageous</span></p>
<p class="toc1"><span href="#/xhtml/24_Chapter12" title="Link target outside of Sample">12 On Patrol, 1915–1916</span></p>
<p class="toc1"><span href="#/xhtml/26_Chapter13" title="Link target outside of Sample">13 The Long Duty Ends, 1916–1917</span></p>
<p class="toc1"><span href="#/xhtml/27_Chapter14" title="Link target outside of Sample">14 Blockade and Trade</span></p>
<p class="toc1a"><span href="#/xhtml/28_Part03" title="Link target outside of Sample"><b>Part Three: A Desperate Battle</b></span></p>
<p class="toc1"><span href="#/xhtml/29_Chapter15" title="Link target outside of Sample">15 <i>Yarrowdale</i> and Prisoners, 1916–1917</span></p>
<p class="toc1"><span href="#/xhtml/30_Chapter16" title="Link target outside of Sample">16 Of Ships and Men, 1917</span></p>
<p class="toc1"><span href="#/xhtml/31_Chapter17" title="Link target outside of Sample">17 First Contact, March 1917</span></p>
<p class="toc1"><span href="#/xhtml/32_Chapter18" title="Link target outside of Sample">18 Battle, March 1917</span></p>
<p class="toc1a"><span href="#/xhtml/33_Part04" title="Link target outside of Sample"><b>Part Four: Endings</b></span></p>
<p class="toc1"><span href="#/xhtml/34_Chapter19" title="Link target outside of Sample">19 Secrets and Rewards</span></p>
<p class="toc1"><span href="#/xhtml/35_Chapter20" title="Link target outside of Sample">20 Postscript</span></p>
<p class="toc1"><span href="#/xhtml/36_Chapter21" title="Link target outside of Sample">21 Coda</span></p>
<p class="toc1a"><span href="#/xhtml/37_Appendix01" title="Link target outside of Sample"><i>Appendices</i></span></p>
<p class="toc1"><span href="#/xhtml/37_Appendix01#Appendix01" title="Link target outside of Sample"><i>Moewe</i>’s Victims</span></p>
<p class="toc1"><span href="#/xhtml/38_Appendix02" title="Link target outside of Sample">Armed Merchant Cruisers of the 10th Cruiser Squadron</span></p>
<p class="toc1"><span href="#/xhtml/39_Appendix03" title="Link target outside of Sample">Example of a T.124 Form</span></p>
<p class="toc1"><span href="#/xhtml/40_Appendix04" title="Link target outside of Sample">Principles of Merchant Ship Construction</span></p>
<p class="toc1"><span href="#/xhtml/41_Appendix05" title="Link target outside of Sample">Andersons in the Shetlands, HMS <i>Dundee</i></span></p>
<p class="toc1"><span href="#/xhtml/42_Select_Bibliography" title="Link target outside of Sample">Select Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?64a9c7e3